/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import ENV from '../config/environment';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class StripeConnectButton extends Component {
  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @tracked
  loading = true;
  @tracked
  connected = false;
  clientId = ENV.APP.stripeClientId;
  extraParams = `&redirect_uri=${window.location.protocol}//${ENV.APP.fqdn}/admin/finance/stripe-connect&always_prompt=true`;

  @alias('session.activeSchool')
  schoolId;

  @optionAlias('finance:payments:enabled')
  schoolOptionEnabled;

  init() {
    super.init(...arguments);
    this.store
      .query('finance/stripe-connection', {
        isConnected: true,
        isEnabled: true,
      })
      .then((connections) => {
        if (!isEmpty(connections)) {
          this.connected = true;
        }
        this.loading = false;
      });
  }
}
